export default __webpack_public_path__ + "84cf3d94b61dd3274e0b9c7e49f988a0.svg";